
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    img(src) {
      if (src.includes('.mp4')) return false
      return true
    },
    pdf(link) {
      if (
        link ==
        '//storyblok.pleinaircdn.com/f/110020/1284x762/fcb50def91/culturegraphic.png'
      ) {
        window.open(
          '//storyblok.pleinaircdn.com/f/110020/x/d5fbe559ad/boj-culture.pdf',
          '_blank'
        )
      }
    },
  },
}
